import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Globe() {
    const mx = useMotionValue(0);
    const my = useMotionValue(0);
    const sx = useSpring(mx, { stiffness: 40, damping: 14 });
    const sy = useSpring(my, { stiffness: 40, damping: 14 });

    useEffect(() => {
        const onMove = (e) => {
            const nx = (e.clientX / window.innerWidth) * 2 - 1;
            const ny = (e.clientY / window.innerHeight) * 2 - 1;
            mx.set(nx * 14);
            my.set(ny * 10);
        };
        window.addEventListener("mousemove", onMove);
        return () => window.removeEventListener("mousemove", onMove);
    }, [mx, my]);

    return (
        <motion.div style={{ x: sx, y: sy }} className="relative w-full max-w-[540px] mx-auto" data-testid="hero-globe">
            <svg viewBox="0 0 640 640" className="w-full h-auto" role="img" aria-label="Mappamondo stilizzato con nodi di connessione, simbolo di Service & Business">
                <defs>
                    <linearGradient id="g-grad" x1="140" y1="80" x2="500" y2="560" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#41C6F1" />
                        <stop offset="1" stopColor="#0A5FC2" />
                    </linearGradient>
                    <radialGradient id="g-sphere" cx="0.38" cy="0.32" r="0.95">
                        <stop offset="0" stopColor="#152136" />
                        <stop offset="0.55" stopColor="#0D1522" />
                        <stop offset="1" stopColor="#090D14" />
                    </radialGradient>
                    <radialGradient id="g-halo" cx="0.5" cy="0.5" r="0.5">
                        <stop offset="0.55" stopColor="rgba(0,210,255,0)" />
                        <stop offset="0.82" stopColor="rgba(0,210,255,0.1)" />
                        <stop offset="1" stopColor="rgba(0,210,255,0)" />
                    </radialGradient>
                </defs>

                <circle cx="320" cy="320" r="318" fill="url(#g-halo)" />

                <g className="globe-spin" style={{ transformOrigin: "320px 320px" }}>
                    <circle cx="320" cy="320" r="300" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="1" strokeDasharray="2 10" />
                    <circle cx="620" cy="320" r="5" fill="#41C6F1" className="globe-node" />
                    <circle cx="40" cy="320" r="3.5" fill="#0A5FC2" className="globe-node d2" />
                </g>
                <g className="globe-spin-rev" style={{ transformOrigin: "320px 320px" }}>
                    <ellipse cx="320" cy="320" rx="300" ry="118" fill="none" stroke="rgba(65,198,241,0.16)" strokeWidth="1" strokeDasharray="3 14" />
                    <circle cx="320" cy="202" r="4" fill="#41C6F1" className="globe-node d3" />
                    <circle cx="320" cy="438" r="4" fill="#41C6F1" className="globe-node d2" />
                </g>

                <circle cx="320" cy="320" r="196" fill="url(#g-sphere)" stroke="url(#g-grad)" strokeWidth="1.6" />

                <g fill="none" stroke="url(#g-grad)">
                    <ellipse cx="320" cy="320" rx="70" ry="196" strokeWidth="1" opacity="0.5" />
                    <ellipse cx="320" cy="320" rx="140" ry="196" strokeWidth="1" opacity="0.3" />
                    <line x1="124" y1="320" x2="516" y2="320" strokeWidth="1" opacity="0.5" />
                    <path d="M156 236 Q320 208 484 236" strokeWidth="1" opacity="0.35" />
                    <path d="M156 404 Q320 432 484 404" strokeWidth="1" opacity="0.35" />
                </g>

                <g fill="none" stroke="url(#g-grad)" strokeWidth="1.4" className="globe-arc">
                    <path d="M320 150 Q 400 190 452 292" strokeDasharray="6 9" />
                    <path d="M452 292 Q 360 400 212 420" strokeDasharray="6 9" opacity="0.7" />
                </g>

                <g>
                    <circle cx="320" cy="150" r="5" fill="#41C6F1" />
                    <circle cx="320" cy="150" r="5" fill="#41C6F1" className="globe-ping" />
                    <circle cx="452" cy="292" r="4" fill="#41C6F1" />
                    <circle cx="452" cy="292" r="4" fill="#41C6F1" className="globe-ping d1" />
                    <circle cx="212" cy="420" r="4" fill="#41C6F1" />
                    <circle cx="212" cy="420" r="4" fill="#41C6F1" className="globe-ping d2" />
                </g>
            </svg>
        </motion.div>
    );
}
